import { useEffect, useState } from "react";
import SquareImage from "@/components/elements/shared/images/SquareImage";

type UserIcon = {
  className?: string;
  src?: string | null;
  alt?: string;
} & Omit<React.ComponentProps<typeof SquareImage>, "src" | "alt">;

export default function UserIcon({
  className = "",
  src,
  alt,
  ...props
}: UserIcon) {
  const defaultIcon = "/img/default-user-icon.svg";
  const [innerSrc, setInnerSrc] = useState<string>(src || defaultIcon);

  useEffect(() => {
    setInnerSrc(src || defaultIcon);
  }, [src]);

  return (
    <SquareImage
      {...props}
      alt={alt ?? "ユーザーアイコン"}
      src={innerSrc}
      className={`size-10 ${className}`}
      imageClassName="text-[0px]"
      style={{
        backgroundImage: `url(${defaultIcon})`,
        backgroundSize: "cover",
      }}
      onError={() => {
        setInnerSrc(defaultIcon);
      }}
    />
  );
}
